module.exports = __webpack_public_path__ + "assets/29013a27d50ffd7860b04499ffe3e931.mp3";